import { handleActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = null

export default handleActions(
  {
    [rawActions.setCoordinatesInfo](state, action) {
      return action.payload
    },
    [rawActions.resetContentViewerState](state, action) {
      return defaultState
    },
  },
  defaultState
)
